import PropType from 'prop-types';
import { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { formatDate } from 'util/date';
import { getMachineType } from 'util/machine-type';
import { TRANSLATION_NAMESPACES } from 'util/translation/constant';
import { MachineMapPin } from 'components/UI/MachineMapPin';
import GoogleMap from 'components/UI/GoogleMap';

export const MachineLocation = ({ machineOverview }) => {
  const { t } = useTranslation(TRANSLATION_NAMESPACES.OVERVIEW);

  const mapCenterLocation = useMemo(() => {
    if (!machineOverview?.data?.length) {
      return undefined;
    }

    const machineData = machineOverview.data.find(
      (machine) => machine.location.latitude && machine.location.longitude
    );

    if (machineData) {
      return [
        parseFloat(machineData.location.latitude),
        parseFloat(machineData.location.longitude)
      ];
    }

    return undefined;
  }, [machineOverview.data]);

  const renderMarkers = useCallback(() => {
    if (!machineOverview?.data?.length) {
      return null;
    }

    const mapMachines = machineOverview.data.filter(
      (machine) => machine.location.latitude && machine.location.longitude
    );

    if (!mapMachines.length) {
      return null;
    }

    return mapMachines.map((machine) => {
      return (
        <MachineMapPin
          key={machine.id}
          lat={machine.location.latitude}
          lng={machine.location.longitude}
          machineType={getMachineType(machine.materialNumber)}
          machineAlias={machine.alias}
          text={formatDate(machine.lastConnectedAt, {
            shortFormat: true
          })}
        />
      );
    });
  }, [machineOverview.data]);

  return (
    <div className="machine-location-overview">
      <div className="widget-title">{t('machineLocationTitle')}</div>
      <div className="map widget-body">
        <GoogleMap
          mapCenterLocation={mapCenterLocation}
          renderMarkers={renderMarkers}
        />
      </div>
    </div>
  );
};

MachineLocation.propTypes = {
  machineOverview: PropType.shape().isRequired
};
